import {TableIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import styles from './ProjectV2.module.css'

type ProjectV2Props = {
  url: string
  title: string
}

export function ProjectV2({url, title}: ProjectV2Props): React.ReactElement {
  return (
    <>
      <TableIcon />{' '}
      <Link href={url} inline className={styles.projectLink}>
        {title}
      </Link>
    </>
  )
}
